import { HttpContextToken } from '@angular/common/http';

/**
 * When set to true, the error interceptor will skip showing notifications for this request.
 * Use for background/silent API calls where 404 or errors are expected.
 */
export const SILENT_HTTP = new HttpContextToken<boolean>(() => false);
